<template>
  <div>
    <form class="needs-validation" @submit.prevent="formSubmit">

      <div class="row">
        <div class="col-md-5">
          <b-form-group label="Sucursal" label-for="idsucursal">
            <b-form-select id="idsucursal" v-model="registro.idsucursal" name="idsucursal"
                           :options="sucursales"
                           value-field="value" text-field="text"></b-form-select>
          </b-form-group>
        </div>

        <div class="col-md-7">
          <b-form-group label="Descripción" label-for="descripcion">
            <b-form-input
                id="descripcion" v-model="registro.descripcion" type="text"
                maxlength="50" name="descripcion"
                :class="{ 'is-invalid': sending && $v.registro.descripcion.$error }"></b-form-input>
            <div v-if="sending && $v.registro.descripcion.$error" class="invalid-feedback">
              <span v-if="!$v.registro.descripcion.required">Identificación del servicio</span>
            </div>
          </b-form-group>
        </div>
        <div class="col-md-12 mb-2">
          <b-form-checkbox id="reemplazaest" v-model="registro.reemplazaest" name="reemplazaest"
                           value="1" unchecked-value="0">
            Reemplaza estacionamiento
          </b-form-checkbox>
          <div style="margin-left: 30px; font-size: 10px; color: #7f8387">
            Cuando el vehículo utilice este Servicio, el valor total del estacionamiento será reemplazado por el valor que se defina en el Tarifario.
          </div>
        </div>
        <div class="col-md-12 mb-2">
          <b-form-checkbox id="valorvariable" v-model="registro.valorvariable" name="valorvariable"
                           value="1" unchecked-value="0">
            Valor Variable
          </b-form-checkbox>
          <div style="margin-left: 30px; font-size: 10px; color: #7f8387">El valor por el Servicio será variable e ingresado por el Cajero, se sumará al valor total del estacionamiento</div>
        </div>
        <div class="col-md-12 mb-2">
          <b-form-checkbox id="descuento" v-model="registro.descuento" name="descuento"
                           value="1" unchecked-value="0">
            Descuento
          </b-form-checkbox>
          <div style="margin-left: 30px; font-size: 10px; color: #7f8387">Por el uso de este Servicio, se descontará el monto definido en el Tarifario del valor total del estacionamiento</div>
        </div>
        <div class="col-md-12 mt-2">
          <b-form-checkbox id="active" v-model="registro.activo" name="activo"
                           value="1" unchecked-value="0">
            Servicio Activo
          </b-form-checkbox>
        </div>

      </div>


      <div class="row">
        <div class="col-md-12" style="margin-bottom: 20px">
        </div>
      </div>

      <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
      <button class="btn btn-primary" type="submit" :disabled="posting" v-if="registro.idservicio == null">Crear</button>
      <button class="btn btn-primary" type="submit" :disabled="posting" v-if="registro.idservicio != null">Actualizar</button>

    </form>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {serviciosService} from "@/helpers/servicios/configuracion/servicios.service";
// import {generalService} from "@/helpers/servicios/configuracion/genera.service";

export default {
  name: "modal-servicio",
  props: ["id"],
  data()  {
    return {
      registro: {},
      error: null,
      sending: false, posting: false,
      sucursales: [],

    }
  },
  watch: {
    id: function() {
    }
  },
  validations: {
    registro: {
      idsucursal: { required },
      descripcion: { required },
    }
  },
  mounted() {
    this.cargarRegistro();
  },
  methods:  {
    async cargarRegistro()  {
      let id = this.id
      this.sucursales = [];
      if (this.id == null)  id = 0
      serviciosService.obtenerServicios(id).then((response) => {
        if (this.id == null)  {
          this.registro = this._registroEmpty()
        } else {
          this.registro = response.servicio
        }
        this.sucursales = response.sucursales;
      })
    },
    formSubmit()    {
      this.sending = true;
      this.$v.$touch();
      if (!this.$v.$invalid)  {
        this.guardarRegistro();
      } else {
        this._error("No olvide seleccionar sucursal y descripción")
      }
    },
    guardarRegistro() {
      this.posting = true
      serviciosService.guardarServicios(this.registro).then((response) => {
        this.posting = false; this.sending = false
        if (response.resultado == "ok") {
          this.$emit("updateServicios", { update: true} );
        } else {
          this._error(response.mensaje);
        }
      }).catch(() => {
        this.posting = false; this.sending = false
        this._error("No fue posible actualizar registro")
      })
    },
    _registroEmpty()  {
      return { idservicio: null, idsucursal: null, descripcion: null, reemplazaest: 0, valorvariable: 0, descuento: 0, activo: 1 };
    },
    _error(mensaje)   {
      this.error = mensaje;
      setTimeout(() => { this.error = null; }, 5000);
    }
  }


}

</script>

<style scoped>

</style>

